import {
  MDXEditorMethods,
  MDXEditor,
  MDXEditorProps,
  listsPlugin,
  quotePlugin,
  toolbarPlugin,
  UndoRedo,
  BoldItalicUnderlineToggles,
  ListsToggle,
  headingsPlugin,
  markdownShortcutPlugin,
  linkPlugin,
  linkDialogPlugin,
  CreateLink,
} from "@mdxeditor/editor";
import React, { ForwardedRef, useRef } from "react";
import "@mdxeditor/editor/style.css";

const ToolbarContents = () => (
  <>
    <UndoRedo />
    <BoldItalicUnderlineToggles />
    <ListsToggle options={["bullet", "number"]} />
    <CreateLink />
  </>
);

const DefaultMarkdownEditor: React.FC<
  { editorRef?: ForwardedRef<MDXEditorMethods> | null } & MDXEditorProps
> = (props) => {
  const { plugins = [] } = props;
  const ref = useRef<MDXEditorMethods>(null);
  plugins.push(
    listsPlugin(),
    quotePlugin(),
    linkPlugin(),
    linkDialogPlugin(),
    toolbarPlugin({
      toolbarContents: ToolbarContents,
    }),
    headingsPlugin(),
    markdownShortcutPlugin(),
  );
  return (
    <MDXEditor ref={props.editorRef ?? ref} {...props} plugins={plugins} />
  );
};

export default DefaultMarkdownEditor;
